import React, { useEffect } from 'react';
import TagManager from 'react-gtm-module';
import { withRouter } from 'react-router-dom';
import { Field, reduxForm } from 'redux-form';
import { states } from '../helpers/demographics';
import validate from '../helpers/emitPersonalInformationValidate';
import focusInputOnError from '../helpers/focusInputOnError';
import { parseStringToNumber } from '../helpers/utils';
import { FormInput, FormNumber, FormRadio, FormSelect } from './';

export function EmitPersonalInformationForm(props: any) {
  const {
    handleSubmit,
    previousPage,
  } = props;

  const stateOptions = states.map((region: any) => ({
    name: region.name,
    value: region.code,
  }));

  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT === 'production') {
      const tagManagerArgs = {
        dataLayer: {
          event: 'vpvDatosCliente',
        },
        dataLayerName: 'datalayer',
      };

      TagManager.dataLayer(tagManagerArgs);
    }
  }, []);

  return (
    <div className="col-12 col-sm-8 col-md-7 col-lg-6 mx-auto mb100">
      <form onSubmit={handleSubmit} noValidate={true}>
        <div className="row flex-column">
          <div className="col-12 form-group mb20">
            <label htmlFor="firstName">Primer nombre</label>
            <Field
              name="firstName"
              type="text"
              placeholder="León"
              component={FormInput}
            />
          </div>
          <div className="col-12 form-group mb20">
            <label htmlFor="middleName">Segundo nombre</label>
            <Field
              name="middleName"
              type="text"
              placeholder="Maximiliano"
              component={FormInput}
            />
          </div>
          <div className="col-12 form-group mb20">
            <label htmlFor="lastName">Apellidos</label>
            <Field
              name="lastName"
              type="text"
              placeholder="Vallejos Ramírez"
              component={FormInput}
            />
          </div>
          <div className="col-12 form-group mb20">
            <label htmlFor="documentId">CURP del asegurado</label>
            <Field
              name="documentId"
              type="text"
              placeholder="Ej ROVI490617HSPDSS05"
              component={FormInput}
            />
          </div>
          <div className="col-12 form-group mb20">
            <label htmlFor="birthdate">Fecha de nacimiento del asegurado</label>
            <Field
              name="birthdate"
              placeholder="31-12-2000"
              inputFormat="##-##-####"
              mask={['d', 'd', 'm', 'm', 'a', 'a', 'a', 'a']}
              component={FormNumber}
            />
          </div>
          <div className="col-12 form-group mb20">
            <label htmlFor="mail">Correo de contacto</label>
            <Field
              name="mail"
              type="mail"
              placeholder="ejemplo@dominio.com"
              component={FormInput}
            />
          </div>
          <div className="col-12 form-group mb20">
            <label htmlFor="phone">Teléfono de contacto</label>
            <Field
              name="phone"
              placeholder="15541234567"
              inputFormat="###########"
              isPhone={true}
              component={FormNumber}
            />
          </div>
          <div className="col-12 form-group mb20">
            <label htmlFor="genre">Género</label>
            <div className="w-100 genre-checkbox-container">
              <Field
                name="genre"
                options={[
                  {
                    id: 'male',
                    text: 'Masculino',
                    value: '01',
                  },
                  {
                    id: 'female',
                    text: 'Femenino',
                    value: '02',
                  },
                ]}
                component={FormRadio}
              />
            </div>
          </div>
          <div className="col-12 form-group mb20">
            <label htmlFor="address">Calle</label>
            <Field
              name="address"
              component={FormInput}
              placeholder="Ej. Dr. Lavista"
            />
          </div>
          <div className="col-12 form-group mb20">
            <label htmlFor="addressNumber">Número</label>
            <Field
              name="addressNumber"
              placeholder="Ej. 189"
              inputFormat="##########"
              normalize={parseStringToNumber}
              component={FormNumber}
            />
          </div>
          <div className="col-12 form-group mb20">
            <label htmlFor="colony">Colonia</label>
            <Field
              name="colony"
              component={FormInput}
              placeholder="Ej. Doctores"
            />
          </div>
          <div className="col-12 form-group mb20">
            <label htmlFor="town">Municipio o delegación</label>
            <Field
              name="town"
              component={FormInput}
              placeholder="Ej. Cuauhtémoc"
            />
          </div>
          <div className="col-12 form-group mb20">
            <label htmlFor="city">Ciudad</label>
            <Field
              name="city"
              component={FormInput}
              placeholder="Ej. Ciudad de México"
            />
          </div>
          <div className="col-12 form-group mb20">
            <label htmlFor="zipcode">Código postal</label>
            <Field
              name="zipcode"
              placeholder="Ej. 06720"
              inputFormat="#####"
              normalize={parseStringToNumber}
              component={FormNumber}
            />
          </div>
          <div className="col-12 form-group mb20">
            <label htmlFor="state">Estado</label>
            <Field
              name="state"
              options={stateOptions}
              placeholder="Selecciona..."
              component={FormSelect}
              isDisabled={!stateOptions.length}
            />
          </div>
          <div className="col-12 mt50">
            <p className="text-dark-gray text-center mb0">
              <small>* El pagador y asegurado deben ser la misma persona</small>
            </p>
          </div>
        </div>
        <div className="row justify-content-center mt30 buttons-container">
          <div className="col-12 col-sm-6">
            <button
              className="btn white back-to-charges"
              type="button"
              onClick={previousPage}
            >
              Volver
            </button>
          </div>
          <div className="col-12 col-sm-6">
            <button
              className="btn primary go-to-payment"
              type="submit"
            >
              Continuar
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}

export default withRouter(
  reduxForm<any, any>({
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    form: 'proposal',
    onSubmitFail: focusInputOnError,
    validate,
  })(EmitPersonalInformationForm),
);
